export interface CategoryItem {
  name: string;
  url: string;
  icon: string;
}

export const categories: CategoryItem[] = [
  { name: 'Shoes', url: 'https://kaspreadsheet.com/category-911-Shoes.html', icon: 'ri-footprint-line' },
  { name: 'Hoodies/Sweaters', url: 'https://kaspreadsheet.com/search-912/name/Shoes.html', icon: 'ri-t-shirt-line' },
  { name: 'T-Shirts', url: 'https://kaspreadsheet.com/search-913/name/Shoes.html', icon: 'ri-t-shirt-air-line' },
  { name: 'Jackets', url: 'https://kaspreadsheet.com/search-914/name/Shoes.html', icon: 'ri-shirt-line' },
  { name: 'Pants/Shorts', url: 'https://kaspreadsheet.com/search-915/name/Shoes.html', icon: 'ri-billiards-line' },
  { name: 'Headwear', url: 'https://kaspreadsheet.com/search-916/name/Shoes.html', icon: 'ri-customer-service-line' },
  { name: 'Sets', url: 'https://kaspreadsheet.com/search-917/name/Shoes.html', icon: 'ri-stack-line' },
  { name: 'Underwear/Underpants', url: 'https://kaspreadsheet.com/search-918/name/Shoes.html', icon: 'ri-checkbox-blank-line' },
  { name: 'Jersey', url: 'https://kaspreadsheet.com/search-919/name/Shoes.html', icon: 'ri-flag-line' },
  { name: 'Accessories', url: 'https://kaspreadsheet.com/search-920/name/Shoes.html', icon: 'ri-glasses-line' },
  { name: 'Bags', url: 'https://kaspreadsheet.com/search-921/name/Shoes.html', icon: 'ri-handbag-line' },
  { name: 'Belts', url: 'https://kaspreadsheet.com/search-922/name/Shoes.html', icon: 'ri-link' },
  { name: 'Perfumes', url: 'https://kaspreadsheet.com/search-923/name/Shoes.html', icon: 'ri-contrast-drop-line' },
  { name: 'Other Stuff', url: 'https://kaspreadsheet.com/search-924/name/Shoes.html', icon: 'ri-more-line' },
];

export const trustBadges = [
  { text: 'Updated Resources', icon: 'ri-refresh-line' },
  { text: 'Curated Finds', icon: 'ri-star-line' },
  { text: 'Beginner Friendly', icon: 'ri-user-smile-line' },
  { text: 'Safety Focused', icon: 'ri-shield-check-line' },
];

export const features = [
  {
    title: 'Save Research Time',
    description: 'Stop spending hours searching through scattered product listings. Our Kakobuy Spreadsheet organizes thousands of verified finds in one accessible database.',
    icon: 'ri-timer-line',
  },
  {
    title: 'Discover Hidden Products',
    description: 'Uncover unique and trending items that casual browsers miss. Our curated spreadsheet lists highlight the best Kakobuy finds across every category.',
    icon: 'ri-search-eye-line',
  },
  {
    title: 'Compare Multiple Finds',
    description: 'Make informed shopping decisions by comparing prices, quality ratings, and shipping options across Kakobuy, CSSBuy, Superbuy, and Oopbuy spreadsheets.',
    icon: 'ri-scales-line',
  },
  {
    title: 'Access Organized Lists',
    description: 'Browse neatly categorized product databases with intuitive filtering. Find exactly what you need — from sneakers to electronics — in seconds.',
    icon: 'ri-file-list-3-line',
  },
  {
    title: 'Stay Updated Daily',
    description: 'Our spreadsheets are refreshed regularly with the latest product drops and trending items so you never miss out on new Kakobuy finds.',
    icon: 'ri-calendar-check-line',
  },
  {
    title: 'Community Verified',
    description: 'Every product in our spreadsheets has been reviewed and verified by real shoppers, ensuring you get accurate and trustworthy information.',
    icon: 'ri-group-line',
  },
];

export const comparisonPlatforms = [
  { name: 'Kakobuy Spreadsheet', resource: '★★★★★', discovery: '★★★★★', experience: 'Excellent', highlight: true },
  { name: 'CSSBuy Spreadsheet', resource: '★★★★☆', discovery: '★★★★☆', experience: 'Very Good', highlight: false },
  { name: 'Superbuy Spreadsheet', resource: '★★★★☆', discovery: '★★★☆☆', experience: 'Good', highlight: false },
  { name: 'Oopbuy Spreadsheet', resource: '★★★☆☆', discovery: '★★★☆☆', experience: 'Good', highlight: false },
];

export const testimonials = [
  {
    name: 'Sarah Mitchell',
    role: 'Fashion Blogger',
    text: 'The Kakobuy Spreadsheet completely transformed how I source products for my content. The organized database saved me countless hours, and I have discovered so many incredible fashion pieces I would have never found on my own.',
    avatar: 'https://readdy.ai/api/search-image?query=Elegant%20professional%20woman%20portrait%20with%20warm%20natural%20lighting%20soft%20cream%20background%20neutral%20tones%20clean%20aesthetic%20editorial%20style%20fashion%20blogger%20vibe%20minimal%20composition%20gentle%20expression&width=120&height=120&seq=avatar-sarah-v3&orientation=squarish',
  },
  {
    name: 'James Chen',
    role: 'Streetwear Enthusiast',
    text: 'I have tried every spreadsheet database out there, and this Kakobuy resource is by far the most comprehensive. The comparison feature between platforms is a game-changer for serious shoppers like me.',
    avatar: 'https://readdy.ai/api/search-image?query=Modern%20young%20man%20portrait%20casual%20style%20streetwear%20aesthetic%20clean%20warm%20background%20soft%20natural%20light%20editorial%20photography%20warm%20neutral%20tones%20minimal%20composition%20confident%20expression&width=120&height=120&seq=avatar-james-v3&orientation=squarish',
  },
  {
    name: 'Emma Rodriguez',
    role: 'Product Reviewer',
    text: 'As someone who reviews products professionally, having access to a well-organized Kakobuy Spreadsheet with verified links and updated pricing is absolutely invaluable. Highly recommended for anyone serious about smart shopping.',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20woman%20portrait%20warm%20lighting%20confident%20expression%20clean%20neutral%20cream%20background%20editorial%20photography%20soft%20shadows%20elegant%20minimal%20composition%20approachable%20vibe&width=120&height=120&seq=avatar-emma-v3&orientation=squarish',
  },
];

export const featuredPosts = [
  {
    title: 'How to Use Kakobuy Spreadsheet for Smarter Shopping in 2026',
    excerpt: 'A complete step-by-step guide covering everything beginners need to know about navigating and maximizing Kakobuy spreadsheets for product discovery.',
    date: 'July 06, 2026',
    category: 'Guides',
    slug: '/kakobuy-spreadsheet-guide',
  },
  {
    title: 'CSSBuy Spreadsheet vs Kakobuy: Which Platform Has Better Finds?',
    excerpt: 'An in-depth comparison of CSSBuy and Kakobuy spreadsheet databases, comparing product variety, update frequency, and community verification.',
    date: 'July 05, 2026',
    category: 'Comparisons',
    slug: '/cssbuy-spreadsheet-guide',
  },
  {
    title: 'Shopping Safety Guide: How to Avoid Fake Kakobuy Spreadsheet Resources',
    excerpt: 'Essential tips and red flags to watch for when browsing Kakobuy finds online, plus how to protect your personal information and verify product authenticity.',
    date: 'July 04, 2026',
    category: 'Safety',
    slug: '/kakobuy-safety-guide',
  },
];